import { Banner, BannerHeading, BannerIcon, BannerSuffix, getColor } from '@aircall/tractor-v2';
import { ExternalLink } from '@components/Link/ExternalLink';
import { checkIsLimitedSupervisor } from '@components/Sidenav/components/SidenavMain/SidenavMain.utils';
import { useCurrentUser } from '@hooks/useCurrentUser/useCurrentUser';
import { useFeaturesFlags } from '@hooks/useFeatures/useFeaturesFlags';
import styled from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';

const StyledExternalLink = styled(ExternalLink)`
  color: ${getColor('text-interactive-secondary')};

  &:hover,
  &:focus {
    color: ${getColor('text-interactive-secondary-hover')};
  }
`;

export function LimitedSupervisorBanner() {
  const { applySupervisorRestrictions } = useFeaturesFlags();
  const { currentUser } = useCurrentUser();
  const { t } = useTranslation();

  const isLimitedSupervisor =
    currentUser && checkIsLimitedSupervisor(currentUser.roles, currentUser.authorizedEntities);
  const visible = applySupervisorRestrictions && isLimitedSupervisor;

  if (!visible) {
    return null;
  }

  return (
    <Banner data-test='limited-supervisor-banner' variant='warning'>
      <BannerIcon />
      <BannerHeading>{t('analytics.limited_supervisor_banner.text')}</BannerHeading>
      <BannerSuffix>
        <StyledExternalLink href={t('analytics.limited_supervisor_banner.link')} target='_blank'>
          {t('generic.learn_more')}
        </StyledExternalLink>
      </BannerSuffix>
    </Banner>
  );
}
